/* eslint-disable import/no-anonymous-default-export */
import { useCallback, useEffect, useState } from "react";
import useFacility from "../../../../../utils/hooks/useFacility";
import { Ticket } from "../../../../models/Ticket";
import { GET_USER_SELECTS_URL } from "../../../../api/apiRoutes";
import { get } from "../../../../api";
import { setErrors } from "../../../../store/alerts/alertsActions";
import { useDispatch } from "react-redux";

export default (accountIds?: string) => {
  const dispatch = useDispatch();
  const facilityIds = useFacility();
  const [tickets, setTickets] = useState<Ticket[]>([]);
  const [loading, setLoading] = useState(false);

  const getTickets = useCallback(async () => {
    setLoading(true);
    const { result, isError, errorTable } = await get(GET_USER_SELECTS_URL(facilityIds, accountIds));
    if (!isError) {
      setTickets(result);
    } else {
      dispatch(setErrors(errorTable));
    }
    setLoading(false);
  }, [dispatch, facilityIds, accountIds]);

  useEffect(() => {
    getTickets();
  }, [getTickets]);

  const refreshTickets = () => {
    getTickets();
  };

  return { tickets, loading, refreshTickets };
};
